import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot, setDoc, getDoc } from "firebase/firestore";
import { useModal } from "../ModalContext";
import GlassLoader from "../components/ui/GlassLoader";

function ProfilePage() {
  const navigate = useNavigate();
  const username = localStorage.getItem("user");

  const { openModal } = useModal();

  const [avatar, setAvatar] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [bio, setBio] = useState("");
  const [online, setOnline] = useState(false);
  const profileLink = `https://iwtb.online/user/${username}`;

  const [posts, setPosts] = useState([]);

  const [comment, setComment] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [collapsed, setCollapsed] = useState({});

  const [createOpen, setCreateOpen] = useState(false);
  const [newPostFile, setNewPostFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [caption, setCaption] = useState("");

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const profileFileRef = useRef(null);

  useEffect(() => {

    if (!username) return;

    const setOnlineStatus = async (isOnline) => {
      await setDoc(doc(db, "users", username), {
        online: isOnline,
        lastSeen: Date.now()
      }, { merge: true });
    };

    setOnlineStatus(true);
    const handleUnload = () => setOnlineStatus(false);
    window.addEventListener("beforeunload", handleUnload);

    return () => {
      setOnlineStatus(false);
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [username]);

  useEffect(() => {

    
    if (!username) return;

    const unsub = onSnapshot(doc(db, "users", username), (snap) => {
  if (snap.exists()) {
    const data = snap.data();

    setAvatar(data.avatar || "");
    setName(data.name || "");
    setStatus(data.status || "");
    setBio(data.bio || "");
    setOnline(data.online || false);

    const safePosts = (data.posts || []).map(p => ({
      ...p,
      comments: p.comments || [],
      likes: p.likes || []
    }));

    setPosts(safePosts);

    setLoading(false); // 🔥 ВОТ ЭТО КЛЮЧ
  }
});

    return () => unsub();
  }, [username]);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "ml_default");

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/dwdmfreoc/image/upload",
      { method: "POST", body: formData }
    );

    const data = await res.json();
    return data.secure_url;
  };

  const changeAvatar = async (file) => {
    const url = await uploadToCloudinary(file);
    await setDoc(doc(db, "users", username), { avatar: url }, { merge: true });
  };

  const addPost = async () => {
    if (!newPostFile) return;

    const imageUrl = await uploadToCloudinary(newPostFile);

    const updatedPosts = [{
      image: imageUrl,
      caption,
      comments: [],
      likes: []
    }, ...posts];

    await setDoc(doc(db, "users", username), { posts: updatedPosts }, { merge: true });

    setCaption("");
    setNewPostFile(null);
    setPreview("");
    setCreateOpen(false);
  };

  const [copied, setCopied] = useState(false);

  const toggleLike = async (index) => {
    const updated = [...posts];
    const likes = updated[index].likes || [];

    updated[index].likes = likes.includes(username)
      ? likes.filter(u => u !== username)
      : [...likes, username];

    await setDoc(doc(db, "users", username), { posts: updated }, { merge: true });
  };

  const addComment = async () => {
    if (!comment.trim()) return;

    const updated = [...posts];

    updated[selectedIndex].comments.push({
      id: Date.now(),
      user: username,
      text: comment,
      replyTo,
      avatar: avatar || "",
      time: Date.now()
    });

    await setDoc(doc(db, "users", username), { posts: updated }, { merge: true });

    setComment("");
    setReplyTo(null);
  };

  const deleteById = async (id) => {
    const updated = [...posts];
    updated[selectedIndex].comments =
      updated[selectedIndex].comments.filter(c => c.id !== id);

    await setDoc(doc(db, "users", username), { posts: updated }, { merge: true });
  };

const openUserModal = async (user) => {
  const snap = await getDoc(doc(db, "users", user));
  if (snap.exists()) {
    setUserModal({
      username: user,
      ...snap.data()
    });
  }
};

const { setPostModal, setUserModal } = useModal();

const openPostModal = (index) => {
  setPostModal({
    posts,
    index,
    ownerUsername: username
  });
};

  const nextPost = () => {
    if (selectedIndex < posts.length - 1) {
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const prevPost = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const toggleCollapse = (id) => {
  setCollapsed(prev => ({
    ...prev,
    [id]: !prev[id]
  }));
};

const renderComments = (comments, parentId = null, level = 0) => {
  return comments
    .filter(c => c.replyTo === parentId)
    .map((c) => {
      const isCollapsed = collapsed[c.id];

      // 👇 проверяем есть ли ответы
      const hasReplies = comments.some(x => x.replyTo === c.id);

      return (
        <div
          key={c.id}
          style={{
            marginLeft: level * 20,
            marginTop: 10
          }}
        >
          <div style={styles.commentRow}>

            {/* 👇 ОБЕРНУЛИ АВАТАРКУ */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img
                src={c.avatar || "https://via.placeholder.com/40"}
                style={styles.commentAvatar}
                onClick={() => openUserModal(c.user)} // 👈 ВОТ ЭТО
/>
              {/* 👇 КНОПКА СВОРАЧИВАНИЯ */}
              {hasReplies && (
                <span
                  onClick={() =>
                    setCollapsed(prev => ({
                      ...prev,
                      [c.id]: !prev[c.id]
                    }))
                  }
                  style={{
                    marginTop: 4,
                    fontSize: 12,
                    cursor: "pointer",
                    opacity: 0.6
                  }}
                >
                  {isCollapsed ? "▶" : "▼"}
                </span>
              )}
            </div>

            {/* 💬 ТЕКСТ */}
            <div style={styles.commentBubble}>
              <b>{c.user}</b>

              <div>{c.text}</div>

              <div style={styles.commentActions}>
                <span onClick={() => setReplyTo(c.id)}>ответить</span>

                {c.user === username && (
                  <span onClick={() => deleteById(c.id)}>удалить</span>
                )}
              </div>
            </div>

          </div>

          {/* 👇 ДОЧЕРНИЕ КОММЕНТЫ */}
          {!isCollapsed &&
            renderComments(comments, c.id, level + 1)
          }
        </div>
      );
    });
};

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "ArrowRight") nextPost();
      if (e.key === "ArrowLeft") prevPost();
      if (e.key === "Escape") setSelectedIndex(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex, posts.length]);

  const [loading, setLoading] = useState(true);

  if (loading) return <GlassLoader />;

  return (
    <> 
      <div style={{ ...styles.container, ...styles.pageEnter }}>
      <div style={styles.content}>
        
       <div style={styles.header}>

<button
  onClick={() => navigate("/chat")}
  style={styles.glassBtn}

  onMouseEnter={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
    e.currentTarget.style.transform = "translateY(-1px)";
  }}

  onMouseLeave={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
    e.currentTarget.style.transform = "translateY(0)";
  }}

  onMouseDown={(e) => {
    e.currentTarget.style.transform = "scale(0.95)";
  }}

  onMouseUp={(e) => {
    e.currentTarget.style.transform = "scale(1)";
  }}
>
  ← Домой
</button>

  <button
  style={styles.glassBtn}
    onClick={() => setSettingsOpen(true)}

  onMouseEnter={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.15)";
    e.currentTarget.style.transform = "translateY(-1px)";
  }}

  onMouseLeave={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
    e.currentTarget.style.transform = "translateY(0)";
  }}

  onMouseDown={(e) => {
    e.currentTarget.style.transform = "scale(0.95)";
  }}

  onMouseUp={(e) => {
    e.currentTarget.style.transform = "scale(1)";
  }}
>
  ⚙️
</button>
</div>

        <div style={styles.profile}>
          <img
            src={avatar || "https://via.placeholder.com/100"}
            style={styles.avatar}
            onClick={() => profileFileRef.current.click()}
          />

          <input
            type="file"
            ref={profileFileRef}
            style={{ display: "none" }}
            onChange={(e) => changeAvatar(e.target.files[0])}
          />

          <div style={{
  width: 10,
  height: 10,
  borderRadius: "50%",
  background: online ? "lime" : "gray",
  marginTop: 5
}} />
          
         <h2 style={{ marginBottom: 5 }}>{name || "Без имени"}</h2>
         <p style={{ marginTop: 0, opacity: 0.7 }}>@{username}</p>

         <div
  onClick={() => {
  navigator.clipboard.writeText(profileLink);
  setCopied(true);
  setTimeout(() => setCopied(false), 1500);
}}
  style={{
    marginTop: 10,
    padding: "8px 12px",
    borderRadius: 12,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    cursor: "pointer",
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    transition: "0.2s"
  }}

  onMouseEnter={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.12)";
  }}

  onMouseLeave={(e) => {
    e.currentTarget.style.background = "rgba(255,255,255,0.06)";
  }}
>
  <span style={{ opacity: 0.7 }}>твоя ссылка</span>

  <span
    style={{
      maxWidth: 160,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      opacity: 0.9
    }}
  >
    {profileLink}
  </span>

  <span style={{ opacity: 0.8, display: "flex", alignItems: "center" }}>
  {copied ? (
    // ✔ check icon
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13L9 17L19 7"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    // 📋 copy icon
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <rect
        x="9"
        y="9"
        width="10"
        height="10"
        rx="2"
        stroke="white"
        strokeWidth="2"
      />
      <rect
        x="5"
        y="5"
        width="10"
        height="10"
        rx="2"
        stroke="white"
        strokeWidth="2"
        opacity="0.5"
      />
    </svg>
  )}
</span>
</div>

         <input
  value={status}
  placeholder="Статус..."
  onChange={(e) => setStatus(e.target.value)}
  onBlur={(e) =>
    setDoc(doc(db, "users", username), {
      status: e.target.value
    }, { merge: true })
  }
  style={{ ...styles.input, marginTop: 10 }}
/>

        <p>{bio}</p>
</div>
<div style={{ display: "flex", justifyContent: "center", marginTop: 15 }}>
  <button
  style={{ ...styles.glassBtn, ...styles.primaryBtn }}
    onClick={() => setCreateOpen(true)}
>
  + Добавить пост
</button>
</div>
        <div style={styles.grid}>
          {posts.map((p, i) => (
  <div key={i} onClick={() => openPostModal(i)}>
    <img src={p.image} style={styles.postImg} />
  </div>
))}
</div>

{createOpen && (
  <div style={styles.modal} onClick={() => setCreateOpen(false)}>
    <div style={styles.modalWrapper}>
      <div
  style={{
    ...styles.modalContent,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 15
  }}
  onClick={(e) => e.stopPropagation()}

  onDragOver={(e) => {
    e.preventDefault();
    e.currentTarget.style.border = "2px dashed #4caf50";
  }}
  onDragLeave={(e) => {
    e.currentTarget.style.border = "none";
  }}
  onDrop={(e) => {
    e.preventDefault();
    e.currentTarget.style.border = "none";

    const file = e.dataTransfer.files[0];
    if (file) {
      setNewPostFile(file);
      setPreview(URL.createObjectURL(file));
    }
  }}
>
  <button onClick={() => setCreateOpen(false)}>✕</button>

  <h3>Новый пост</h3>

  {preview && (
    <img
  src={preview}
  style={{
    width: "100%",
    maxHeight: "400px",
    objectFit: "contain",
    borderRadius: 10
  }}
/>
  )}

  {/* зона загрузки */}
  <div
    onClick={() => document.getElementById("fileInput").click()}
    style={{
      width: "100%",
      maxWidth: 300,
      padding: 20,
      border: "2px dashed #555",
      borderRadius: 10,
      textAlign: "center",
      cursor: "pointer",
      opacity: 0.8
    }}
  >
    Перетащи файл сюда или нажми
  </div>

  <input
    id="fileInput"
    type="file"
    style={{ display: "none" }}
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        setNewPostFile(file);
        setPreview(URL.createObjectURL(file));
      }
    }}
  />

  <textarea
  placeholder="Описание..."
  value={caption}
  onChange={(e) => setCaption(e.target.value)}
  style={{
    width: "100%",
    maxWidth: 400,
    minHeight: 120,
    padding: 10,
    borderRadius: 8,
    border: "none",
    background: "#333",
    color: "#fff",
    resize: "none"
  }}
/>

  <button onClick={addPost}>Опубликовать</button>
</div>
    </div>
  </div>
)}

{settingsOpen && (
  <div style={styles.modal} onClick={() => setSettingsOpen(false)}>
    <div style={styles.modalWrapper}>
      <div
        style={styles.settingsModalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          style={styles.closeBtn}
          onClick={() => setSettingsOpen(false)}
        >
          ✕
        </button>

        <h2 style={{ marginBottom: 20 }}>Настройки</h2>

        <div style={styles.fieldBlock}>
          <div style={styles.label}>Имя</div>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={(e) =>
              setDoc(doc(db, "users", username), {
                name: e.target.value
              }, { merge: true })
            }
            style={styles.inputGlass}
          />
        </div>

        <div style={styles.fieldBlock}>
          <div style={styles.label}>О себе</div>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            onBlur={(e) =>
              setDoc(doc(db, "users", username), {
                bio: e.target.value
              }, { merge: true })
            }
            style={styles.textareaGlass}
          />
        </div>

      </div>
    </div>
  </div>
)}

</div>  
</div> 

</>
);
}

const styles = {
  container: {
    color: "#fff",
    background: "#1e1e1e",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center"
  },
  content: { width: "100%", maxWidth: 700, padding: 15 },
  header: { display: "flex", justifyContent: "space-between" },
  profile: { display: "flex", flexDirection: "column", alignItems: "center" },
  avatar: { width: 110, height: 110, borderRadius: "50%", cursor: "pointer" },
  input: { background: "#333", border: "none", padding: 10, color: "#fff", borderRadius: 8, width: "100%" },
  grid: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginTop: 20 },
  postImg: {
  width: "100%",
  height: "100%",
  aspectRatio: "1/1",
  objectFit: "cover",
  borderRadius: 8
},
modalContent: {
  width: "95%",
  maxWidth: 500,
  padding: 25,
  borderRadius: 16,

  background: "#1e1e1e", // 👈 обычный фон вместо стекла
boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
},

settingsModalContent: {
  width: "95%",
  maxWidth: 500,
  padding: 25,
  borderRadius: 16,
  background: "#1e1e1e",
  boxShadow: "0 10px 40px rgba(0,0,0,0.5)",

  display: "flex",
  flexDirection: "column",
  alignItems: "center" // 👈 оставляем тут
},

postModalContent: {
  width: "auto",              // 👈 вместо 95%
  maxWidth: "98vw",   // не шире экрана
  maxHeight: "90vh",  // не выше экрана
  padding: 20,
  borderRadius: 12,
  background: "#222",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  maxHeight: "90vh",
  overflowY: "auto",

  // 👇 прозрачный скролл
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(255,255,255,0.15) transparent"
},
postInner: {
  width: "fit-content",
  maxWidth: "90vw"
},

  fieldBlock: {
    width: "100%",
    maxWidth: 400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 15
  },

  primaryBtn: {
  background: "rgba(255,255,255,0.15)",
  border: "1px solid rgba(255,255,255,0.25)",
},

  label: {
    marginBottom: 6,
    textAlign: "center",
    color: "#ccc"
  },

  inputGlass: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    textAlign: "center",
    boxSizing: "border-box",
    outline: "none"
  },

  glassBtn: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  gap: 6,
  padding: "8px 12px",

  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.15)",

  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(8px)",

  color: "#fff",
  fontSize: 13,
  cursor: "pointer",

  transition: "all 0.2s ease"
},

  textareaGlass: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    textAlign: "center",
    boxSizing: "border-box",
    resize: "none",
    minHeight: 90,
    outline: "none"
  },
  
  modal: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.7)", // 👈 ВАЖНО
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
},
  modalWrapper: { display: "flex", alignItems: "center", justifyContent: "center", height: "100%" },

  modalImg: {
  maxWidth: "100%",
  maxHeight: "85vh", // 👈 больше, чем было
  width: "auto",
  height: "auto",
  objectFit: "contain",
  borderRadius: 10
},
  commentsBox: {
  marginTop: 10
},
  commentRow: { display: "flex", gap: 10 },
 commentAvatar: {
  width: 35,
  height: 35,
  borderRadius: "50%",
  cursor: "pointer" // 👈 добавь
},
  commentBubble: { background: "#333", padding: 10, borderRadius: 10, flex: 1 },
  commentActions: { fontSize: 12, marginTop: 5, display: "flex", gap: 10, cursor: "pointer" },
 commentInputBox: {
  display: "flex",
  marginTop: 10,
  gap: 8,
  alignItems: "center"
},
topBar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 20
},

  userModal: {
  width: "90%",
  maxWidth: 400,
  background: "#222",
  padding: 20,
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
},

settingsInput: {
  width: "100%",
  maxWidth: 300,
  padding: 10,
  marginBottom: 15,
  borderRadius: 8,
  border: "none",
  background: "#333",
  color: "#fff",
  textAlign: "center"
},

settingsTextarea: {
  width: "100%",
  maxWidth: 350,
  minHeight: 120,
  padding: 10,
  borderRadius: 8,
  border: "none",
  background: "#333",
  color: "#fff",
  resize: "none",
  textAlign: "center"
},

userModalWide: {
  width: "90%",
  maxWidth: 800,
  background: "#1e1e1e",
  borderRadius: 16,
  padding: 20,

  display: "flex",
  gap: 20,
  position: "relative"
},

userLeft: {
  width: 200,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center"
},

userRight: {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
},

userAvatarBig: {
  width: 100,
  height: 100,
  borderRadius: "50%",
  marginBottom: 10
},

userBioBox: {
  background: "#2a2a2a",
  padding: 10,
  borderRadius: 10,
  minHeight: 80
},

userPostsRow: {
  display: "flex",
  gap: 10,
  marginTop: 15
},

userPostPreview: {
  width: 80,
  height: 80,
  objectFit: "cover",
  borderRadius: 8
},

goProfileBtn: {
  marginTop: 20,
  padding: "12px 16px",
  borderRadius: 10,
  border: "none",
  background: "#666666",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
},

closeBtn: {
  position: "absolute",
  top: 10,
  right: 10,
  background: "transparent",
  border: "none",
  color: "#fff",
  fontSize: 18,
  cursor: "pointer"
},

pageEnter: {
  opacity: 0,
  transform: "translateY(20px)",
  animation: "fadeInPage 0.4s ease forwards"
},

};

export default ProfilePage;